import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { Typography, Button, Popover, MenuList, MenuItem, IconButton } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import WelcomeText from "../../components/WelcomeText";
import { styled } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import api from '../../api/user';

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { formatDate } from "../../utils/helper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontFamily: "Gilroy-Bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: " rgba(103, 30, 120, 0.1)",
    fontFamily: "gilroy-regular",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    // border: 0,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

let theme = createTheme({
  palette: {
    primary: {
      main: "#671E78",
    },
    secondary: {
      main: "#edf2ff",
    },
  },
  typography: {
    fontFamily: "Gilroy-Bold",
    h1: {
      fontFamily: "Gilroy-Bold",
      fontSize: "52px",
    },
  },
});

const Cbt = () => {
  const [value, setValue] = useState(0);
  const userInstance = JSON.parse(localStorage.lasmabObj) || {};
  const token = localStorage.lasmabAuthToken || "";
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const getData = async () => {
    setLoading(true);
    try {
      let res = await api.getCBTLists(
        token,
        userInstance.schoolId,
        userInstance.classId,
      );
      console.log(res);
      if (res.status === true && res.statusCode === 2) {
        setData(res.data);
        setLoading(false);
      } else {
        toast.error(res?.message);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      toast.error(err.data?.Message);
    }
  };

  const practiceData = data.filter((row) => row?.cbtType?.toLowerCase() === "practice");
  const testData = data.filter((row) => row?.cbtType?.toLowerCase() === "test");
  // const examData = data.filter((row) => row.cbtType?.toLowerCase() === "exam");

  useEffect(() => {
    getData();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          sx={{ fontFamily: "gilroy-regular", margin: "0 auto", width: "90%" }}
        >
          <Box sx={{ borderBottom: "2px solid #671E78" }}>
            <WelcomeText />
            <Typography
              variant="h1"
              sx={{
                mt: 3,
                fontSize: {
                  lg: "42px",
                  md: "42px",
                  sm: "38px",
                  xs: "30px",
                },
              }}
            >
              CBT
            </Typography>
          </Box>
          {/* .......,,,,,,,,,,,,,,.............Tables..............,,,,,,,,,,,,,,,,............... */}
          <Box
            mt={5}
            pb={3}
            sx={{
              border: "1px solid #671E78",
              borderRadius: "20px",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  borderRadius: "20px 20px 0px 0px",
                  background: "rgba(0, 0, 0, 0.12)",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Tabs
                  value={value}
                  sx={{ width: "100%" }}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="Practice"
                    {...a11yProps(0)}
                    sx={{
                      width: "35%",
                      fontFamily: "gilroy-bold",
                      color: "#000",
                    }}
                  />
                  <Tab
                    label="Test"
                    {...a11yProps(1)}
                    sx={{
                      width: "35%",
                      fontFamily: "gilroy-bold",
                      color: "#000",
                    }}
                  />
                  {/* <Tab
                    label="Exam"
                    {...a11yProps(2)}
                    sx={{
                      width: "35%",
                      fontFamily: "gilroy-bold",
                      color: "#000",
                    }}
                  /> */}
                </Tabs>
              </Box>
              <TabPanel
                value={value}
                index={0}
                sx={{ p: 0, fontFamily: "Gilroy-Regular" }}
              >
                <TableContainer sx={{ width: "100%", p: 0 }}>
                  <Table
                    sx={{ minWidth: 700, p: 0, fontFamily: "Gilroy-Regular" }}
                    aria-label="customized table"
                  >
                    <TableHead
                      sx={{
                        backgroundColor: "rgba(103, 30, 120, 0.1)",
                        backgroundColor: "rgba(103, 30, 120, 0.1)",
                        width: "100%",
                      }}
                    >
                      <TableRow sx={{ p: 0 }}>
                        <StyledTableCell>Posted Date</StyledTableCell>
                        <StyledTableCell>Subject</StyledTableCell>
                        <StyledTableCell>Tittle</StyledTableCell>
                        <StyledTableCell>Posted By</StyledTableCell>
                        <StyledTableCell>Duration</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: "center" }}>Status</StyledTableCell>
                        <StyledTableCell>My Score</StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ fontFamily: "Gilroy-Regular" }}>
                      {loading ?
                        <StyledTableCell>Loading...</StyledTableCell>
                        : (practiceData?.length > 0 ?
                          practiceData?.map((row) => (
                            <StyledTableRow key={row.id}>
                              <StyledTableCell component="th" scope="row">
                                {formatDate(row.postedDate)}
                              </StyledTableCell>
                              <StyledTableCell>{row.subject}</StyledTableCell>
                              <StyledTableCell>{row.title}</StyledTableCell>
                              <StyledTableCell>{row.postedBy}</StyledTableCell>
                              <StyledTableCell>{row.duration}</StyledTableCell>
                              <StyledTableCell
                                sx={{
                                  fontFamily: "gilroy-regular",
                                  color: row.status === "ATTEMPTED" ? "red" : "green",
                                  textAlign: "center",
                                  fontSize: "12px",
                                }}
                              >
                                {row.status}
                              </StyledTableCell>
                              <StyledTableCell>
                                {row.myScore}
                              </StyledTableCell>
                              <StyledTableCell>
                                {(!row.isMultipleAttempt && row.status === "ATTEMPTED") ? (
                                  <Button
                                    variant="outlined"
                                    disabled
                                    sx={{
                                      borderRadius: "100px",
                                      fontFamily: "gilroy-regular",
                                      px: 4,
                                    }}
                                  >
                                    Done
                                  </Button>
                                ) : (
                                  <Link
                                    to={`/cbt/viewtest/${row?.id}/${row?.subjectId}/${encodeURIComponent(
                                      row?.subject
                                    )}/${encodeURIComponent(row?.title)}/${row?.duration}`}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <Button
                                      variant="outlined"
                                      sx={{
                                        borderRadius: "100px",
                                        fontFamily: "gilroy-regular",
                                        px: 4,
                                      }}
                                    >
                                      {row.isMultipleAttempt && row.status === "ATTEMPTED"
                                        ? "Re-Attempt"
                                        : "Start"}
                                    </Button>
                                  </Link>
                                )}
                              </StyledTableCell>
                              <StyledTableCell>
                                <IconButton onClick={(event) => handleClick(event, row)}>
                                  <MoreVertIcon />
                                </IconButton>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))
                          : (
                            <StyledTableCell>No Available Practice CBT</StyledTableCell>
                          )
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <TableContainer sx={{ width: "100%", p: 0 }}>
                  <Table
                    sx={{ minWidth: 700, p: 0 }}
                    aria-label="customized table"
                  >
                    <TableHead
                      sx={{
                        backgroundColor: "rgba(103, 30, 120, 0.1)",
                        width: "100%",
                      }}
                    >
                      <TableRow sx={{ p: 0 }}>
                        <StyledTableCell>Posted Date</StyledTableCell>
                        <StyledTableCell>Subject</StyledTableCell>
                        <StyledTableCell>Tittle</StyledTableCell>
                        <StyledTableCell>Posted By</StyledTableCell>
                        <StyledTableCell>Duration</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: "center" }}>Status</StyledTableCell>
                        <StyledTableCell>Score</StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ fontFamily: "Gilroy-Regular" }}>
                      {loading ?
                        <StyledTableCell>Loading...</StyledTableCell>
                        : (
                          testData.length > 0 ?
                            testData?.map((row) => (
                              <StyledTableRow key={row.id}>
                                <StyledTableCell component="th" scope="row">
                                  {formatDate(row.postedDate)}
                                </StyledTableCell>
                                <StyledTableCell>{row.subject}</StyledTableCell>
                                <StyledTableCell>{row.title}</StyledTableCell>
                                <StyledTableCell>{row.postedBy}</StyledTableCell>
                                <StyledTableCell>{row.duration}</StyledTableCell>
                                <StyledTableCell
                                  sx={{
                                    fontFamily: "gilroy-regular",
                                    color: row.status === "ATTEMPTED" ? "red" : "green",
                                    textAlign: "center",
                                    fontSize: "12px",
                                  }}
                                >
                                  {row.status}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {row.myScore}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {(!row.isMultipleAttempt && row.status === "ATTEMPTED") ? (
                                    <Button
                                      variant="outlined"
                                      disabled
                                      sx={{
                                        borderRadius: "100px",
                                        fontFamily: "gilroy-regular",
                                        px: 4,
                                      }}
                                    >
                                      Done
                                    </Button>
                                  ) : (
                                    <Link
                                      to={`/cbt/viewtest/${row?.id}/${row?.subjectId}/${encodeURIComponent(
                                        row?.subject
                                      )}/${encodeURIComponent(row?.title)}/${row?.duration}`}
                                      style={{ textDecoration: "none" }}
                                    >
                                      <Button
                                        variant="outlined"
                                        sx={{
                                          borderRadius: "100px",
                                          fontFamily: "gilroy-regular",
                                          px: 4,
                                        }}
                                      >
                                        {row.isMultipleAttempt && row.status === "ATTEMPTED"
                                          ? "Re-Attempt"
                                          : "Start"}
                                      </Button>
                                    </Link>
                                  )}
                                </StyledTableCell>

                                <StyledTableCell>
                                  <IconButton onClick={(event) => handleClick(event, row)}>
                                    <MoreVertIcon />
                                  </IconButton>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))
                            : (
                              <StyledTableCell>No Available Practice CBT</StyledTableCell>
                            )
                        )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
            </Box>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Box
                sx={{
                  bgcolor: "#671E78",
                  color: "#fff",
                  fontFamily: "Gilroy-Regular",
                  px: 3,
                }}
              >
                <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
                  {selectedItem?.status === "NEW" ? (
                    <MenuItem sx={{ fontFamily: "Gilroy-Regular", color: "gray" }} disabled>
                      View Result
                    </MenuItem>
                  ) : (
                    <Link
                      to={`/cbt/view-test-result/${selectedItem?.id}/${selectedItem?.subjectId}/${encodeURIComponent(
                        selectedItem?.subject
                      )}/${encodeURIComponent(selectedItem?.title)}/${selectedItem?.duration}/${encodeURIComponent(
                        selectedItem?.myScore
                      )}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <MenuItem sx={{ fontFamily: "Gilroy-Regular" }}>View Result</MenuItem>
                    </Link>
                  )}
                </MenuList>

              </Box>
            </Popover>
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
};

export default Cbt;
